import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const IntervalTimerToolPage = () => (
  <View style={styles.container}>
    <Text style={styles.title}>Interval Timer</Text>
    {/* Qui verrà integrato il componente Interval Timer */}
    <Text style={{marginTop:24, color:'#888'}}>In sviluppo...</Text>
  </View>
);

const styles = StyleSheet.create({
  container: { flex: 1, padding: 24, backgroundColor: '#f7fafd', alignItems: 'center' },
  title: { fontSize: 28, fontWeight: 'bold', color: '#1976d2', marginBottom: 18, textAlign: 'center' },
});

export default IntervalTimerToolPage;
